import BaseService from "@/services/BaseService";

export default class XippAuthService extends BaseService {
  constructor() {
    super('/auth');
  }

  async GetTokenFull() {
    return await this.http.get(`${this._serviceName}/token/full`);
  }
}
